<button
  [type]="type"
  [disabled]="disabled"
  class="flex items-center justify-center px-6 font-bold bg-white border rounded-full text-md h-input-height-phone for-laptop-up:h-input-height-laptop text-nowrap border-borderDefault hover:text-secondary focus:text-primary text-primary hover:bg-buttonOutlinedHover text-buttonOutlinedDefault focus:outline outline-outlineFocus disabled:focus-none disabled:outline-none focus:border-borderDefault focus:border-2 disabled:border-outlineDisabled disabled:focus:outline-none disabled:hover:bg-white disabled:text-tertiary disabled:cursor-not-allowed"
  [style.width]="width"
  [style.height]="height"
>
  <ng-content></ng-content>
</button>
